import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DQBOpen {
    isOpen: boolean;
}
const initialState: DQBOpen = {
    isOpen: false,
};
const DQBOpenSlice = createSlice({
    name: 'DQBOpen',
    initialState,
    reducers: {
        setDQBOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setDQBOpen } = DQBOpenSlice.actions;
export default DQBOpenSlice.reducer;
